import { useCallback, useEffect, useMemo, useState } from "react";

import { toast } from "react-hot-toast";

import {
    Activate_Rest_Menu_Restaurant_Category_Put,
    Activate_Restaurant_Category_Put,
    All_Restaurant_Category_List_Post,
    DeActivate_Rest_Menu_Restaurant_Category_Put,
    DeActivate_Restaurant_Category_Put,
    Delete_Rest_Menu_Restaurant_Category_Delete,
    Delete_Restaurant_Category_Delete,
    Deleted_Restaurant_Category_List_POST,
    Get_Restaurant_Non_Steal_Deal_Category_Key_Value_List_Post,
    Get_Restaurant_Printer_Key_Value_List_Post,
    Get_Restaurant_Tax_Key_Value_List_Post,
    Get_Restaurant_Timing_Group_Key_Value_Pair_List_Post,
    Revive_Rest_Menu_Restaurant_Category_Put,
    Revive_Restaurant_Category_Put,
} from "api/ApiConst";
import { callGetApi, callPostApi } from "api/ApiCaller";
import { DELIVERY_PARTNERS_AVAILABILITIES, DINE_IN, HOME_DELIVERY, SECTION_LOADER, STEAL_DEAL, SWIGGY, TAKEAWAY, TYPE_AVAILABILITIES, ZOMATO } from "utils/constants";
import { getImageSrcViaRefId, handleActive, handleDelete, handleInactive, handleRevive } from "utils/UserUtils";
import { API_SUCCESS } from "api/ResponseCodes";

import CheckboxButton from "components/common/CheckboxButton";
import PaginationDataTable from "components/common/PaginationDataTable";
import CustomButton from "components/common/CustomButton";
import PageHeading from "components/common/PageHeading";
import RestaurantCategoryAddEdit from "./RestaurantCategoryAddEdit";
import Select from "react-select";


const availabilitiesOptions = [
    { label: "All Category", value: "AllCategory" },
    { label: "Dine In Category", value: "DineIn" },
    { label: "Home Delivery Category", value: "HomeDelivery" },
    { label: "Take away Category", value: "TakeAway" },
    // { label: "Steal Deal Category", value: "StealDeal" },
]

const customStyles = {
    control: (provided) => ({
        ...provided,
        width: 190, // Set the desired width
    }),
};


const RestaurantCategoryMaster = () => {
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [viewDeletedList, setViewDeletedList] = useState(false);
    const [recordID, setRecordID] = useState(null);
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
    const [timingGroupKeyPairList, setTimingGroupKeyPairList] = useState([]);
    const [categoryTaxKeyPairList, setCategoryTaxKeyPairList] = useState([]);
    const [categoryKeyPairList, setCategoryKeyPairList] = useState([]);
    const [printerKeyValuePairList, setPrinterKeyValuePairList] = useState([]);
    const [ownedItem, setOwnedItem] = useState(true)
    const [itemAvailability, setItemAvailability] = useState({ label: "All Category", value: "AllCategory" });

    useEffect(() => {
        if (!showAddUpdateModal) {
            getCategoryKeyPairList();
            setRecordID(null);
            setOwnedItem(true);
        }
    }, [showAddUpdateModal]);

    useEffect(() => {
        getTimingGroupKeyPairList();
        getCategoryTaxKeyPairList();
        getPrinterKeyValuePairList();
    }, []);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    // Get Timing Group Key Pair List
    const getTimingGroupKeyPairList = () => {
        let rUrl = Get_Restaurant_Timing_Group_Key_Value_Pair_List_Post;
        const rObj = {};
        callPostApi(SECTION_LOADER, rUrl, rObj, {}, (response) => {
            if (response.errorCode === API_SUCCESS) {
                setTimingGroupKeyPairList(response.responsePacket);
            } else {
                toast.error(response.message);
            }
        });
    };

    // Get Category Tax Key Pair List
    const getCategoryTaxKeyPairList = () => {
        let rUrl = Get_Restaurant_Tax_Key_Value_List_Post;
        const rObj = {};
        callPostApi(SECTION_LOADER, rUrl, rObj, {}, (response) => {
            if (response.errorCode === API_SUCCESS) {
                setCategoryTaxKeyPairList(response.responsePacket);
            } else {
                toast.error(response.message);
            }
        });
    };

    // Get non-steal-deal Parent Category Key Pair List
    const getCategoryKeyPairList = useCallback(() => {
        let rUrl = Get_Restaurant_Non_Steal_Deal_Category_Key_Value_List_Post;
        const rObj = {};
        callPostApi(SECTION_LOADER, rUrl, rObj, {}, (response) => {
            if (response.errorCode === API_SUCCESS) {
                setCategoryKeyPairList(response.responsePacket);
            } else {
                toast.error(response.message);
            }
        });
    }, [refreshFlag]);

    const getPrinterKeyValuePairList = () => {
        callGetApi(SECTION_LOADER, Get_Restaurant_Printer_Key_Value_List_Post, {}, (response) => {
            if (response.errorCode === API_SUCCESS) {
                setPrinterKeyValuePairList(response.responsePacket);
            } else {
                toast.error(response.message);
            }
        });
    }


    const columns = useMemo(
        () => [
            {
                id: "status",
                name: "",
                selector: (row) => {
                    if (row.active) {
                        return <div className="led-green" title="Active" />;
                    } else {
                        return <div className="led-red" title="Inactive" />;
                    }
                },
                width: "60px",
                sortable: false,
            },
            {
                id: "categoryIconRefId",
                name: "",
                selector: (row, i) => (
                    <div className="list-img" key={row.title + "-" + i}>
                        <img src={getImageSrcViaRefId(row.categoryIconRefId)} alt="category icon" />
                    </div>
                ),
                width: "70px",
                sortable: false,
            },
            {
                id: "title",
                name: "Title",
                selector: (row) => (<span className="parent-owned-flag">
                    {row.owned && <span className="badge bg-primary owned-flag" title="Owned">O</span>} {""}
                    {row.title}{row.splitBill && <span className={`split-bill ${row.splitBill ? "bg-success" : "bg-danger"}`} title="Split Bill">Splited</span>}
                </span>),
                sortable: false,
                wrap: true,
            },
            {
                id: "parentCategoryTitle",
                name: "Parent Category",
                selector: (row) => <>{row.parentCategoryTitle}</>,
            },
            {
                id: "availabilities",
                name: "Availability",
                selector: (row) =>
                    TYPE_AVAILABILITIES.map((type, i) =>
                        (type !== STEAL_DEAL) && (row.availabilities.find((data) => data.toLowerCase() === type.toLowerCase()) ? (
                            <span className="badge-available" title={type} key={row.title + "-" + type + "-" + i}>
                                {type === DINE_IN ? "Di" : type === HOME_DELIVERY ? "De" : type === TAKEAWAY ? "Ta" : "Sd"}
                            </span>
                        ) : (
                            <span className="badge-unavailable" title={type} key={row.title + "-" + type + "-" + i}>
                                {type === DINE_IN ? "Di" : type === HOME_DELIVERY ? "De" : type === TAKEAWAY ? "Ta" : "Sd"}
                            </span>
                        ))
                    ),
                sortable: false,
            },
            {
                id: "aggregatorAvailabilities",
                name: "D. Partner",
                selector: (row) =>
                    DELIVERY_PARTNERS_AVAILABILITIES.map((type, i) =>
                        row.aggregatorAvailabilities.find((data) => data.toLowerCase() === type.toLowerCase()) ? (
                            <span className="badge-available" title={type} key={row.title + "-" + type + "-" + i}>
                                {type === ZOMATO ? "Zo" : type === SWIGGY ? "Sw" : ""}
                            </span>
                        ) : (
                            <span className="badge-unavailable" title={type} key={row.title + "-" + type + "-" + i}>
                                {type === ZOMATO ? "Zo" : type === SWIGGY ? "Sw" : ""}
                            </span>
                        )
                    ),
                sortable: false,
            },
            {
                id: "action",
                name: "",
                selector: (row) => getActionButtons(row),
                width: "100px",
                sortable: false,
            },
        ],
        [handleRefresh]
    );

    const getActionButtons = (row) => {
        return (
            <div className="d-flex align-items-center justify-content-between">
                {!row.deleted && (
                    <button className="listBtn me-2" onClick={() => handleEdit(row)}>
                        <i className="bx bx-pencil"></i>
                    </button>
                )}
                <div className="dropdown">
                    <button className="btn btn-primary btn-flat btn-addon btn-xs dropdown-toggle" title="More" data-bs-toggle="dropdown" aria-expanded="false" style={{ padding: "5px 10px 8px 10px" }}>
                        <i className="bx bx-chevron-down"></i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                        <>
                            {row.deleted ? (
                                <li onClick={() => handleReviveData(row)}>
                                    <i className="bx bx-log-out-circle"></i> Revive
                                </li>
                            ) : (
                                <>
                                    <li onClick={() => handleDeleteData(row)}>
                                        <i className="bx bx-trash"></i> Delete
                                    </li>
                                    <li onClick={() => handleActiveInactive(row)}>
                                        {row.active ? (
                                            <>
                                                <i className="bx bx-x-circle"></i> Inactive
                                            </>
                                        ) : (
                                            <>
                                                <i className="bx bx-check-circle"></i> Active
                                            </>
                                        )}
                                    </li>
                                </>
                            )}
                        </>
                    </ul>
                </div>
            </div>
        );
    };

    const handleEdit = (row) => {
        setRecordID(row.uuid);
        setOwnedItem(row.owned);
        setShowAddUpdateModal(true);
    };

    const handleActiveInactive = (row) => {
        if (row.active) {
            const rUrl = row.owned ? DeActivate_Restaurant_Category_Put : DeActivate_Rest_Menu_Restaurant_Category_Put;
            handleInactive(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
        } else {
            const rUrl = row.owned ? Activate_Restaurant_Category_Put : Activate_Rest_Menu_Restaurant_Category_Put;
            handleActive(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
        }
    };

    //Delete Record
    const handleDeleteData = (row) => {
        const rUrl = row.owned ? Delete_Restaurant_Category_Delete : Delete_Rest_Menu_Restaurant_Category_Delete;
        handleDelete(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    //Revive Record
    const handleReviveData = (row) => {
        const rUrl = row.owned ? Revive_Restaurant_Category_Put : Revive_Rest_Menu_Restaurant_Category_Put;
        handleRevive(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    const handleToggleDeletedView = () => setViewDeletedList(!viewDeletedList);

    return (
        <>
            {PageHeading("Food Category List", "Dashboard", "/")}
            <div className="card">
                <div className="d-flex createButton" >
                    <CustomButton handleClick={() => setShowAddUpdateModal(true)} title="Create New" iconClass="bx bx-plus" buttonClass="" />
                    <Select className="ms-2" maxMenuHeight={150} styles={customStyles} options={availabilitiesOptions} value={itemAvailability} onChange={(e) => setItemAvailability(e)} />
                </div>
                <div className="card-body tableView">
                    <PaginationDataTable
                        paginationUrl={viewDeletedList ? Deleted_Restaurant_Category_List_POST + "/" + itemAvailability.value : All_Restaurant_Category_List_Post + "/" + itemAvailability.value}
                        serverSidePagination={false}
                        search={true}
                        pagination={false}
                        columns={columns}
                        filterColumn={"title"}
                        filter={true}
                    />
                    <CheckboxButton title="Deleted List" handleClick={handleToggleDeletedView} additionalClass="deletedBtn ml-auto" />
                </div>
            </div>
            {showAddUpdateModal && (
                <RestaurantCategoryAddEdit
                    show={showAddUpdateModal}
                    hideModal={() => setShowAddUpdateModal(false)}
                    recordID={recordID}
                    handleRefresh={handleRefresh}
                    categoryKeyPairList={categoryKeyPairList}
                    categoryTaxKeyPairList={categoryTaxKeyPairList}
                    timingGroupKeyPairList={timingGroupKeyPairList}
                    printerKeyValuePairList={printerKeyValuePairList}
                    ownedItem={ownedItem}
                    isStealDealCategory={false}
                />
            )}
        </>
    );
};

export default RestaurantCategoryMaster;
